import React from 'react';
import { connect } from 'react-redux';
import { PageBody, PageContent } from '@bit/knotchinc.web-react-components.page';
import FilterSideMenu from '@bit/knotchinc.web-react-components.filter-side-menu';
import DateFilter from '@bit/knotchinc.web-react-components.date-filter';
import ContentCard from 'components/Global/Card/ContentCard.jsx';
import FolderCard from 'components/Global/Card/FolderCard.jsx';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import ChecklistFilter from 'components/Global/Filters/ChecklistFilter/ChecklistFilter.jsx';
import TagFilter from 'components/Global/Filters/TagFilter/TagFilter.jsx';
import EntityFilter from 'components/Global/Filters/EntityFilter/EntityFilter.jsx';
// import SearchFilter from 'components/Global/Filters/SearchFilter/SearchFilter.jsx';
import SelectedFiltersBar from 'components/Global/Filters/SelectedFiltersBar/SelectedFiltersBar.jsx';
import LayoutToggle from 'components/Global/LayoutToggle/LayoutToggle.jsx';
import { ContentFeedContainer, FolderCardFeedContainer } from 'components/Pages/Home/styled.js';
import { SET_KEYWORDS_FILTER, SET_BRANDS_FILTER, SET_CATEGORIES_FILTER } from 'components/Global/Filters/actions.js';
import Mixpanel from 'helpers/Mixpanel.js';
import PublisherPaidStats from './PublisherPaidStats.jsx';
import { LeftSideBarWrapper } from '../styled.js';
import {
  fetchPublisherKeywords,
  fetchPublisherCategories,
  fetchPublisherBrands,
  SET_PUBLISHER_PAID_CONTENT_FILTER,
  fetchPublisherPaidContent,
  fetchPartnershipList,
} from '../actions';

class PublisherPaidContentView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      layoutIsSpread: false,
    };
  }

  componentDidMount() {
    const { match: { params: { entityId } } } = this.props;
    Mixpanel.track('view Publisher Paid Content', { id: entityId });
  }


  handleToggle() {
    this.setState(prevState => {
      if (prevState.layoutIsSpread) {
        Mixpanel.track('changed to content feed');
        return { layoutIsSpread: false };
      }
      Mixpanel.track('changed to folder feed');
      return { layoutIsSpread: true };
    });
  }

  render() {
    const { layoutIsSpread } = this.state;
    const { metadata, paidContentList, categoriesList, keywordsList, brandsList, paidPartnershipList,
      getBrands, getCategories, getKeywords, getFeed, getPartnershipFeed, match: { params: { entityId } } } = this.props;

    return (
      <PageBody>
        <PublisherPaidStats entityId={entityId} background={metadata.data.hero_image_url} />
        <LeftSideBarWrapper>
          <LayoutToggle toggled={layoutIsSpread} toggleHandler={() => this.handleToggle()} />
          <FilterSideMenu clearAll={() => {}}>
            <DateFilter filterAction={SET_PUBLISHER_PAID_CONTENT_FILTER} />
            {/* <SearchFilter filterAction={SET_PUBLISHER_PAID_CONTENT_FILTER} /> */}
            <TagFilter
              title="keywords"
              type="keyword_tags"
              filters={paidContentList.filters}
              items={keywordsList}
              fetch={clear => getKeywords(clear)}
              selectedItems={paidContentList.filters.keyword_tags}
              filterAction={SET_PUBLISHER_PAID_CONTENT_FILTER}
              listAction={SET_KEYWORDS_FILTER}
            />
            <ChecklistFilter
              type="categories"
              filters={paidContentList.filters}
              items={categoriesList}
              fetch={clear => getCategories(clear)}
              selectedItems={paidContentList.filters.categories}
              filterAction={SET_PUBLISHER_PAID_CONTENT_FILTER}
              listAction={SET_CATEGORIES_FILTER}
            />
            <EntityFilter
              title="brands"
              type="brand_ids"
              filters={paidContentList.filters}
              items={brandsList}
              fetch={clear => getBrands(clear)}
              selectedItems={paidContentList.filters.brand_ids}
              filterAction={SET_PUBLISHER_PAID_CONTENT_FILTER}
              listAction={SET_BRANDS_FILTER}
            />
          </FilterSideMenu>
        </LeftSideBarWrapper>
        <PageContent>
          <SelectedFiltersBar filters={paidContentList.filters} filterAction={SET_PUBLISHER_PAID_CONTENT_FILTER} hiddenFilters={['content_type']} />
          { layoutIsSpread ? (
            <ContentFeedContainer>
              <ListSync
                fetch={clear => getFeed(clear)}
                listStore={paidContentList}
                loadOnScroll
                actionType={SET_PUBLISHER_PAID_CONTENT_FILTER}
                loadingPlaceholders={12}
              >
                <ContentCard />
              </ListSync>
            </ContentFeedContainer>
          ) : (
            <FolderCardFeedContainer>
              <ListSync
                fetch={clear => getPartnershipFeed(clear)}
                listStore={paidPartnershipList}
                loadOnScroll
                actionType={SET_PUBLISHER_PAID_CONTENT_FILTER}
              >
                <FolderCard entity={metadata.data} />
              </ListSync>
            </FolderCardFeedContainer>
          )}
        </PageContent>
      </PageBody>
    );
  }
}

const mapStateToProps = ({
  BrandsList: { brandsList },
  KeywordsList: { keywordsList },
  CategoriesList: { categoriesList },
  PublisherProfile: { paidContentList, paidPartnershipList, metadata },
}) => ({ paidContentList, categoriesList, keywordsList, brandsList, paidPartnershipList, metadata });

const mapDispatchToProps = (dispatch, { match: { params: { entityId } } }) => ({
  getFeed: clear => dispatch(fetchPublisherPaidContent(clear, entityId)),
  getPartnershipFeed: clear => dispatch(fetchPartnershipList(clear, entityId, 'publisher')),
  getKeywords: clear => dispatch(fetchPublisherKeywords(clear, entityId)),
  getCategories: clear => dispatch(fetchPublisherCategories(clear, entityId)),
  getBrands: clear => dispatch(fetchPublisherBrands(clear, entityId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublisherPaidContentView);
